import { POST_INFO_APPLY_START } from '../../types';

export const post_info_apply = (payload) => ({
  type: POST_INFO_APPLY_START,
  payload,
});
